function fetchCartRecommendations() {
  const container = document.getElementById('cart-recommendations');
  if (!container) return;
  const productId = container.dataset.productId;
  if (!productId) return;

  const localeRoot = (container.dataset.localeRoot || '/').replace(/\/$/, '');
  const headingText = container.dataset.heading || 'You may also like';
  const addLabel = container.dataset.addLabel || 'Add';

  fetch(`${localeRoot}/recommendations/products.json?product_id=${productId}&limit=4&intent=related`)
    .then((r) => r.json())
    .then(({ products }) => {
      if (!products || products.length === 0) {
        container.innerHTML = '';
        return;
      }
      const currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      const fmt = (cents) => {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
          }).format(cents / 100);
        } catch (e) {
          return '€' + (cents / 100).toFixed(2);
        }
      };

      const heading = `<p class="cart-recommendations__heading">${headingText}</p>`;
      const cards = products
        .map((p) => {
          const variant = p.variants[0];
          const safeTitle = p.title.replace(/</g, '&lt;').replace(/>/g, '&gt;');
          const productUrl = p.url || `${localeRoot}/products/${p.handle}`;
          const img = p.featured_image
            ? `<a href="${productUrl}" class="cart-rec-card__image-link"><img class="cart-rec-card__image cart-rec-card__image--loading" src="${p.featured_image}" alt="${safeTitle}" width="70" height="70" loading="eager"></a>`
            : '<div class="cart-rec-card__image cart-rec-card__image--placeholder"></div>';
          return `
            <div class="cart-rec-card">
              ${img}
              <div class="cart-rec-card__info">
                <a href="${productUrl}" class="cart-rec-card__title-link"><p class="cart-rec-card__title">${safeTitle}</p></a>
                <p class="cart-rec-card__price">${fmt(p.price)}</p>
              </div>
              <button
                class="cart-rec-card__btn"
                data-variant-id="${variant.id}"
                onclick="addRecToCart(${variant.id}, this)"
              >${addLabel}</button>
            </div>`;
        })
        .join('');

      container.innerHTML = heading + cards;
      container.querySelectorAll('.cart-rec-card__image--loading').forEach(function(img) {
        if (img.complete) {
          img.classList.remove('cart-rec-card__image--loading');
        } else {
          img.addEventListener('load', function() { img.classList.remove('cart-rec-card__image--loading'); }, { once: true });
          img.addEventListener('error', function() { img.classList.remove('cart-rec-card__image--loading'); }, { once: true });
        }
      });
    })
    .catch(() => {});
}

function addRecToCart(variantId, btn) {
  btn.disabled = true;
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  formData.append('sections', 'cart-drawer,cart-icon-bubble');
  formData.append('sections_url', window.location.pathname);

  fetch('/cart/add.js', { method: 'POST', body: formData })
    .then((r) => r.json())
    .then((state) => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.renderContents(state);
    })
    .catch(() => {
      btn.disabled = false;
    });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.initSwipeToDismiss();
  }

  initSwipeToDismiss() {
    let startY = 0;
    let currentDeltaY = 0;
    let isDragging = false;

    this.addEventListener('touchstart', (e) => {
      if (window.innerWidth > 749) return;
      const drawerInner = this.querySelector('.drawer__inner');
      if (!drawerInner) return;

      const touch = e.touches[0];
      const shippingBar = drawerInner.querySelector('.cart-shipping-bar');
      const header = drawerInner.querySelector('.drawer__header');
      const dragZoneEl = shippingBar || header;
      if (!dragZoneEl) return;

      if (touch.clientY > dragZoneEl.getBoundingClientRect().bottom) return;

      startY = touch.clientY;
      currentDeltaY = 0;
      isDragging = true;
      drawerInner.style.transition = 'none';
    }, { passive: true });

    this.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const drawerInner = this.querySelector('.drawer__inner');
      if (!drawerInner) return;

      const deltaY = e.touches[0].clientY - startY;
      if (deltaY <= 0) {
        drawerInner.style.transform = 'translateY(0)';
        return;
      }
      currentDeltaY = deltaY;
      drawerInner.style.transform = `translateY(${deltaY}px)`;
      e.preventDefault();
    }, { passive: false });

    const onDragEnd = () => {
      if (!isDragging) return;
      isDragging = false;
      const drawerInner = this.querySelector('.drawer__inner');
      if (!drawerInner) return;

      drawerInner.style.transition = 'transform var(--duration-default) ease';

      if (currentDeltaY > window.innerHeight * 0.5) {
        drawerInner.style.transform = 'translateY(100%)';
        drawerInner.addEventListener('transitionend', () => {
          this.close();
          drawerInner.style.transform = '';
          drawerInner.style.transition = '';
        }, { once: true });
      } else {
        drawerInner.style.transform = 'translateY(0)';
        drawerInner.addEventListener('transitionend', () => {
          drawerInner.style.transform = '';
          drawerInner.style.transition = '';
        }, { once: true });
      }
    };

    this.addEventListener('touchend', onDragEnd);
    this.addEventListener('touchcancel', onDragEnd);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    fetchCartRecommendations();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if (this.activeElement) this.activeElement.blur();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      fetchCartRecommendations();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  onCartUpdate() {
    return super.onCartUpdate().then(() => {
      fetchCartRecommendations();
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartRecommendations);
}

function bindRemoveSpinners() {
  document.querySelectorAll('cart-drawer .cart-remove-button').forEach(function(btn) {
    if (btn._spinnerBound) return;
    btn._spinnerBound = true;
    btn.addEventListener('click', function() {
      btn.classList.add('cart-remove-button--loading');
    });
  });
}

bindRemoveSpinners();

(function() {
  var drawerInner = document.getElementById('CartDrawer');
  if (!drawerInner) return;
  new MutationObserver(bindRemoveSpinners).observe(drawerInner, { childList: true, subtree: true });
})();
